import { useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

import { inputSearch } from "_constants";
import { useAppDispatch } from "store/store";
import { setSearchTermProject } from "store/slicer/GestioneProjectsSlice";
import { useDebounce, useUnmountEffect } from "primereact/hooks";

export const InputSearchProject = () => {
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement>(null);

  const [inputValue, debouncedValue, setInputValue] = useDebounce("", 500);

  const handleChange = (e: any) => {
    setInputValue(e.target.value);
  };

  useEffect(() => {
    if (debouncedValue !== null && debouncedValue !== undefined) {
      dispatch(setSearchTermProject(debouncedValue));
    }
  }, [debouncedValue, dispatch]);

  useUnmountEffect(() => {
    dispatch(setSearchTermProject(""));
  });

  return (
    <IconField iconPosition="left">
      <InputIcon className="cta pi pi-search"></InputIcon>
      <InputText
        ref={inputRef}
        v-model="value1"
        placeholder={inputSearch}
        value={inputValue}
        onChange={handleChange}
        className="width-100"
      />
    </IconField>
  );
};
